export default {
  get: {

  },
  post: {
    // 查询企业是否认证接口
    judgeCompanyRegistered: "/dmall-ladder/dmallladder/contract/judgeCompanyRegistered",
    //  企业注册
    companyRegister: "/dmall-ladder/dmallladder/contract/companyRegister",
    // 生成电子签章
    generateSignatureImg: "/dmall-ladder/dmallladder/contract/generateSignatureImg",
    // 保存电子签章
    saveSignatureImg: "/dmall-ladder/dmallladder/contract/saveSignatureImg",
    // 删除电子签章
    deleteSignatureImg: "/dmall-ladder/dmallladder/contract/deleteSignatureImg",
    // 根据客户id查询有效的签章列表接口
    getSignatureImgListByGroupId: "/dmall-ladder/dmallladder/contract/getSignatureImgListByGroupId",
    // 查询合同列表
    getContractsInfo: "/dmall-ladder/dmallladder/contract/getContractsInfo",
    // 签署合同
    signContract: "/dmall-ladder/dmallladder/contract/signContract",
    // 拒签合同
    refuseContract: "/dmall-ladder/dmallladder/contract/refuseContract",
    // 预览合同
    getContractFile: "/dmall-ladder/dmallladder/contract/getContractFile",
    // 验证码验证接口
    checkCodeByPhone: "/dmall-ladder/dmallladder/contract/checkCodeByPhone",
    // 发短信验证码
    sendPhoneCode: "/dmall-ladder/dmallladder/contract/sendPhoneCode",
  }
}